<template>
  <div class="base-box">
    <van-field v-model="params.login" @blur="loginCheck" class="input-item" left-icon="manager"
      placeholder="请输入您的登录名(数字和字母)"></van-field>
    <van-field class="input-item" :type="isShowPW?'password':''" left-icon="lock"
      :right-icon="isShowPW?'closed-eye':'eye-o'" @click-right-icon="isShowPW = !isShowPW" v-model="params.password"
      placeholder="请输入您的登录密码"></van-field>
    <van-field class="input-item" :type="isShowPW2?'password':''" left-icon="lock"
      :right-icon="isShowPW2?'closed-eye':'eye-o'" @click-right-icon="isShowPW2 = !isShowPW2" v-model="params.password2"
      placeholder="请再次输入您的登录密码"></van-field>
    <van-button class="successedBtn" type="primary" size="large" @click="submit">完成</van-button>
    <van-checkbox class="rule-box" checked-color="#228ccd" v-model="checked">
      我已阅读
      <span @click.stop="rule">《入会须知》</span>
    </van-checkbox>
    <van-dialog v-model="showRule" title="入会须知" show-cancel-button width="80%">
      <div class='content' style="">
        <rule></rule>
      </div>

    </van-dialog>
  </div>
</template>

<script>
  import { Field, Button, Checkbox, Toast, Dialog } from "vant";
  import {
    getRegisterCode,
    checkMobile,
    verifyRegisterCode,
    fastRegisterMember,
    checkLogin
  } from "@/api/login";
  import rule from "../../rule.vue";
  export default {
    data() {
      return {
        isSpend: false,
        time: 60,
        params: {
          mobile: "",
          code: "",
          login: "",
          password: "",
          password2: "",
          memberCategory: 2
        },
        isShowPW: true,
        isShowPW2: true,
        checked: false,
        isDisabled: false,
        beginClientX: 0,           /*距离屏幕左端距离*/
        mouseMoveStata: false,     /*触发拖动状态  判断*/
        maxwidth: '',               /*拖动最大宽度，依据滑块宽度算出来的*/
        confirmWords: '拖动滑块验证',   /*滑块文字*/
        confirmSuccess: false,           /*验证成功判断*/
        showRule: false
      };
    },
    components: {
      [Field.name]: Field,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Dialog.Component.name]: Dialog.Component,
      rule
    },
    mounted() {

    },
    methods: {
      loginCheck() {
        if (/[\u4E00-\u9FA5]/g.test(this.params.login)) {
          Toast("登录名只能是数字和字母!");
        }
      },
      rule() {
        this.showRule = true;
        // this.$router.push({ name: "rule" });
      },
      async getCode() {
        let mobile = this.params.mobile;

        if (this.isSpend) {
          return;
        }

        if (!this.$regexp.mobile(mobile)) {
          Toast("请输入正确的手机号");
          return false;
        }

        await this.checkMobiles(mobile);
        //生成签名
        let timestamp = new Date().getTime();
        let data = "appSecretKey=captcha_codes&mobile=" + mobile + "&timestamp=" + timestamp;
        let sign = this.$md5(data);
        getRegisterCode({ mobile: mobile, sign: sign, timestamp: timestamp }).then(res => {
          if (res.success) {
            this.isSpend = true;
            this.time = 60;
            this.count();
          }
        });
      },
      checkMobiles(mobile) {
        let params = {
          mobile
        };

        return new Promise(resolve => {
          checkMobile(params).then(res => {
            if (!res.result && res.success) {
              resolve();
            } else {
              Toast.fail("该手机号码已经注册过！");
            }
          }).catch(() => {
            Toast.fail("该手机号码已经注册过！");
          });
        });
      },
      count() {
        --this.time;
        if (this.time > 0) {
          setTimeout(() => {
            this.count();
          }, 1000);
        } else {
          this.isSpend = false;
        }
      },
      register() {
        let params = this.params;

        fastRegisterMember(params).then(res => {
          if (res.success) {
            this.$emit("updateInfo", res.result);
            this.$emit("sendActive", 1);
          } else {
            if (res.messageCode == '110001') {
              Toast.fail("用户名已存在!");
            } else if (res.messageCode == '110002') {
              Toast.fail("手机号已存在!");
            } else {
              Toast.fail("注册失败!");
            }
          }
        });
      },
      async submit() {
        let isChecked = this.$regexp.password(this.params.password),
          regexpPassword = this.$regexp.chinese(this.params.password);

        if (!this.params.login) {
          Toast("请输入登录名!");
          return;
        }

        if (
          (this.params.password || "").indexOf("&") !== -1 ||
          (this.params.password2 || "").indexOf("&") !== -1
        ) {
          Toast("密码不能包含&符号");
          return;
        }

        if (!this.params.password || !isChecked || regexpPassword) {
          Toast("密码必须为8-16为包含字母、数字、符号中至少2种且不能有空格!");
          return;
        }

        if (this.params.password !== this.params.password2) {
          Toast("两次输入的密码不正确!");
          return;
        }

        if (!this.checked) {
          Toast("请阅读入会须知！");
          return;
        }

        let params = {
          login: this.params.login,
        };
        checkLogin(params).then(res => {
          if (res.success) {
            this.register();
          }else {
            Toast.fail("该用户名已经注册过！");
          }
        });
      },
      mousedownFn: function (e) {
        if (!this.confirmSuccess) {
          e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
          this.mouseMoveStata = true;
          this.beginClientX = e.changedTouches[0].clientX;
        }
      },        //mousedoen 事件
      successFunction() {
        this.confirmSuccess = true
        this.confirmWords = '验证通过';
        this.isDisabled = false;
        if (window.addEventListener) {
          document.getElementsByTagName('html')[0].removeEventListener('touchmove', this.mouseMoveFn);
          document.getElementsByTagName('html')[0].removeEventListener('touchend', this.moseUpFn);
        } else {
          document.getElementsByTagName('html')[0].removeEventListener('touchend', () => { });
        }
        document.getElementsByClassName('drag_text')[0].style.color = '#fff'
        document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
        document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
      },                //验证成功函数
      mouseMoveFn(e) {
        if (this.mouseMoveStata) {
          let width = e.changedTouches[0].clientX - this.beginClientX;
          if (width > 0 && width <= this.maxwidth) {
            document.getElementsByClassName('handler')[0].style.left = width + 'px';
            document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
          } else if (width > this.maxwidth) {
            this.successFunction();
          }
        }
      },                   //mousemove事件
      moseUpFn(e) {
        this.mouseMoveStata = false;
        var width = e.changedTouches[0].clientX - this.beginClientX;
        if (width < this.maxwidth) {
          document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
          document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
        }
      }                       //mouseup事件
    },
    mounted() {
      if (!this.mouseMoveStata) {
        this.isDisabled = true;
      };
      // this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
      // document.getElementsByTagName('html')[0].addEventListener('touchmove', this.mouseMoveFn);
      // document.getElementsByTagName('html')[0].addEventListener('touchend', this.moseUpFn)
    }
  };
</script>

<style lang="less" scoped>
  .input-item {
    padding: 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #dfdfdf;

    i {
      color: #aaa;
      margin-right: 10px;
    }

    &+.input-item {
      margin-top: 15px;
    }
  }

  .input-sms {
    padding: 0;
    padding-bottom: 12px;
    border-bottom: 1px solid #dfdfdf;
  }

  .successedBtn {
    margin-top: 30px;
    height: 48px !important;
    line-height: 48px;
  }

  .rule-box {
    display: flex;
    margin-top: 20px;
    justify-content: center;

    span {
      color: #228ccd;
    }
  }

  .drag {
    position: relative;
    background-color: #e8e8e8;
    width: 100%;
    height: 34px;
    font-size: 14px;
    line-height: 34px;
    margin: 20px 0;
    text-align: center;
  }

  .handler {
    width: 40px;
    height: 32px;
    border: 1px solid #ccc;
    cursor: move;
  }

  .handler_bg {
    background: #fff url("../../../assets/images/arroe.png") no-repeat center;
  }

  .handler_ok_bg {
    background: #fff url("../../../assets/images/chenggong.png") no-repeat center;
  }

  .drag_bg {
    background-color: #7ac23c;
    height: 34px;
    width: 0px;
  }

  .drag_text {
    position: absolute;
    top: 0px;
    width: 100%;
    text-align: center;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    -o-user-select: none;
    -ms-user-select: none;
  }

  .content {
    overflow-y: scroll;
    max-height: 500px;
    width: 100%;
  }
</style>
